@if (dataChunk(); as chunk) {
  <lib-list-table
    [headers]="['', 'PY', 'CY', 'ΔPY', '', 'ΔPY%', '', 'L12M', '']"
    (libOutsideClick)="dismissSelected()"
  >
    @for (measure of focusMeasures(); track measure.code) {
      @let focusDataPoint = chunk.dataPoints | selectDataPoint: measure.code : periodCode() : date();
      @let pyDataPoint = chunk.dataPoints | selectDataPoint: measure.code + '_PY' : periodCode() : date();
      @let
      relativeDataPoint = chunk.dataPoints | selectDataPoint: measure.growthMeasureRelativeCode : periodCode() : date();
      @let
      absoluteDataPoint = chunk.dataPoints | selectDataPoint: measure.growthMeasureAbsoluteCode : periodCode() : date();

      <tr
        [attr.data-sentiment]="focusDataPoint?.sentiment"
        [class.selected]="measure === selectedMeasure()"
      >
        <td>
          <div class="title">
            <lib-direction-indicator [value]="focusDataPoint?.sentiment"/>
            {{ measure.shortName }}
          </div>
        </td>
        <td class="number">
          {{ pyDataPoint?.value | formatByMeasure: measure }}
        </td>
        <td class="number">
          {{ focusDataPoint?.value | formatByMeasure: measure }}
        </td>
        <td class="number">
          {{ absoluteDataPoint?.value | formatByMeasure: measure.absoluteGrowthMeasure }}
        </td>
        <td class="bar-chart">
          <lib-bar-minichart
            [value]="absoluteDataPoint?.value"
            [isAligned]="measure.alignment === Alignment.Aligned"
          />
        </td>
        <td class="number">
          {{ relativeDataPoint?.value | formatByMeasure: measure.relativeGrowthMeasure }}
        </td>
        <td class="bar-chart">
          <lib-bar-minichart
            [maxPositive]="relativeMinMax()?.max"
            [maxNegative]="relativeMinMax()?.min"
            [value]="relativeDataPoint?.value"
            [isAligned]="measure.alignment === Alignment.Aligned"
          />
        </td>
        <td>
          <lib-l12m-line-chart
            [dataPoints]="chunk.dataPoints"
            [date]="date()"
            [period]="periodCode()"
            [measure]="measure"
          />
        </td>
        <td class="action-btn">
          <button (click)="selectMeasure(measure)" class="popover-btn" #toggle>
            <svg width="24" height="24" viewBox="0 0 18 18" fill="currentColor">
              <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownSLine"></use>
            </svg>
          </button>
          @if (selectedMeasure() === measure) {
            <div class="popover-content"

                 [attr.data-sentiment]="(chunk.dataPoints | selectDataPoint: measure.code : periodCode() : date())?.sentiment"
            >
              @if (topPerspective(); as perspective) {
                <lib-report-button
                  [perspective]="perspective"
                  [options]="{
              focusMeasure: measure,
              focusPeriod: periodCode()
            }"
                  [reportPath]="reportPath()"
                />
              }

              <lib-drilldown
                [dimensionItems]="chunk.dimensionItems"
                (drillDown)="handleDrilldown($event, measure)"
              />
            </div>
          }
        </td>
      </tr>
    }
  </lib-list-table>
}
